import { render, staticRenderFns } from "./NewBooking.vue?vue&type=template&id=45028bd6&scoped=true&"
import script from "./NewBooking.vue?vue&type=script&lang=js&"
export * from "./NewBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45028bd6",
  null
  
)

export default component.exports